"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _colorManipulator = require("@mui/system/colorManipulator");
var _elementTypeAcceptingRef = _interopRequireDefault(require("@mui/utils/elementTypeAcceptingRef"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _isFocusVisible = _interopRequireDefault(require("@mui/utils/isFocusVisible"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("../utils/createSimplePaletteValueFilter"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _Typography = _interopRequireDefault(require("../Typography"));
var _linkClasses = _interopRequireWildcard(require("./linkClasses"));
var _getTextDecoration = _interopRequireDefault(require("./getTextDecoration"));
var _jsxRuntime = require("react/jsx-runtime");
var v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, component = ownerState.component, focusVisible = ownerState.focusVisible, underline = ownerState.underline;
    var slots = {
        root: [
            'root',
            "underline".concat((0, _capitalize.default)(underline)),
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, _composeClasses.default)(slots, _linkClasses.getLinkUtilityClass, classes);
};
var LinkRoot = (0, _zeroStyled.styled)(_Typography.default, {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles["underline".concat((0, _capitalize.default)(ownerState.underline))],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: function(param) {
                    var underline = param.underline, ownerState = param.ownerState;
                    return underline === 'always' && ownerState.color !== 'inherit';
                },
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            }
        ].concat(_to_consumable_array(Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)()).map(function(param) {
            var _param = _sliced_to_array(param, 1), color = _param[0];
            return {
                props: {
                    underline: 'always',
                    color: color
                },
                style: {
                    '--Link-underlineColor': theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / 0.4)") : (0, _colorManipulator.alpha)(theme.palette[color].main, 0.4)
                }
            };
        })), [
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? "rgba(".concat(theme.vars.palette.text.primaryChannel, " / 0.4)") : (0, _colorManipulator.alpha)(theme.palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.vars ? "rgba(".concat(theme.vars.palette.text.secondaryChannel, " / 0.4)") : (0, _colorManipulator.alpha)(theme.palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: _define_property({
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    }
                }, "&.".concat(_linkClasses.default.focusVisible), {
                    outline: 'auto'
                })
            }
        ])
    };
}));
var Link = /*#__PURE__*/ React.forwardRef(function Link(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiLink'
    });
    var theme = (0, _zeroStyled.useTheme)();
    var className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'primary' : _props_color, _props_component = props.component, component = _props_component === void 0 ? 'a' : _props_component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props_underline = props.underline, underline = _props_underline === void 0 ? 'always' : _props_underline, _props_variant = props.variant, variant = _props_variant === void 0 ? 'inherit' : _props_variant, sx = props.sx, other = _object_without_properties(props, [
        "className",
        "color",
        "component",
        "onBlur",
        "onFocus",
        "TypographyClasses",
        "underline",
        "variant",
        "sx"
    ]);
    var _React_useState = _sliced_to_array(React.useState(false), 2), focusVisible = _React_useState[0], setFocusVisible = _React_useState[1];
    var handleBlur = function(event) {
        if (!(0, _isFocusVisible.default)(event.target)) {
            setFocusVisible(false);
        }
        if (onBlur) {
            onBlur(event);
        }
    };
    var handleFocus = function(event) {
        if ((0, _isFocusVisible.default)(event.target)) {
            setFocusVisible(true);
        }
        if (onFocus) {
            onFocus(event);
        }
    };
    var ownerState = _object_spread_props(_object_spread({}, props), {
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LinkRoot, _object_spread_props(_object_spread({
        color: color,
        className: (0, _clsx.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant
    }, other), {
        sx: _to_consumable_array(v6Colors[color] === undefined ? [
            {
                color: color
            }
        ] : []).concat(_to_consumable_array(Array.isArray(sx) ? sx : [
            sx
        ])),
        style: _object_spread({}, other.style, underline === 'always' && color !== 'inherit' && !v6Colors[color] && {
            '--Link-underlineColor': (0, _getTextDecoration.default)({
                theme: theme,
                ownerState: ownerState
            })
        })
    }));
});
process.env.NODE_ENV !== "production" ? Link.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The color of the link.
   * @default 'primary'
   */ color: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'primary',
            'secondary',
            'success',
            'error',
            'info',
            'warning',
            'textPrimary',
            'textSecondary',
            'textDisabled'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: _elementTypeAcceptingRef.default,
    /**
   * @ignore
   */ onBlur: _propTypes.default.func,
    /**
   * @ignore
   */ onFocus: _propTypes.default.func,
    /**
   * @ignore
   */ style: _propTypes.default.object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * `classes` prop applied to the [`Typography`](https://mui.com/material-ui/api/typography/) element.
   */ TypographyClasses: _propTypes.default.object,
    /**
   * Controls when the link should have an underline.
   * @default 'always'
   */ underline: _propTypes.default.oneOf([
        'always',
        'hover',
        'none'
    ]),
    /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */ variant: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'body1',
            'body2',
            'button',
            'caption',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'inherit',
            'overline',
            'subtitle1',
            'subtitle2'
        ]),
        _propTypes.default.string
    ])
} : void 0;
var _default = exports.default = Link;
